import { useCallback, useRef } from 'react';
import { printHtml } from '@/utils/print';

interface UseReportPrintOptions {
  title: string;
  extraStyles?: string;
}

export function useReportPrint({ title, extraStyles }: UseReportPrintOptions) {
  const printRef = useRef<HTMLDivElement | null>(null);

  const handlePrint = useCallback(async () => {
    const node = printRef.current;
    if (!node) return;

    await printHtml({
      title,
      extraStyles,
      content: node.innerHTML,
    });
  }, [title, extraStyles]);

  return {
    printRef,
    handlePrint,
  };
}
